module.exports = __webpack_public_path__ + "img/B7.56d17f0c.png";